<label [id]="id" class="control control-checkbox sis-checkbox" data-cy="checkbox">
  <input type="checkbox" [formControl]="control" [name]="name" [attr.aria-describedby]="name + '_errors'" data-cy="the-real-checkbox">
  <span class="control-indicator" [class.invalid]="control.invalid && control.touched" [attr.aria-hidden]="true"></span>
  <span *ngIf="label">{{label | translate}}</span>
  <ng-content select=".sis-form-checkbox-label-content"></ng-content>
</label>
<sis-validation-errors [control]="control" [formFieldId]="name" [ariaLive]="false" />
